import React, { Fragment, useEffect, useState } from 'react'
import { JobStatus } from './JobStatus'
import { JobTechnichian } from './JobTechnichian'
import { JobGroup } from './JobGroup'
import {
  Row,
  Col,
  Divider,
  Card,
  Modal,
  Button,
  Popconfirm,
  message,
} from 'antd'
import { JobShowPostpone } from './JobShowPostpone'
import JobView from './job-view/index'
import Gallery from '../gallery/gallery-list'
import { HomeOutlined, UserOutlined } from '@ant-design/icons'
import InformStore from '../../stores/InformStore'
import { JobDateTime } from './JobDateTime'
import { Config } from '../../config'
import { JobService } from '../../services'
import { Moment } from '../../helpers'
import { Observer } from 'mobx-react'

export const JobItem = (props) => {
  const colDate = { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 }
  const colDetail = { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 }

  const [beforeImages, setBeforeImages] = useState([])
  const [afterImages, setAfterImages] = useState([])
  const [selected, setSelected] = useState(null)
  const [visibleModalView, setVisibleModalView] = useState(false)
  const job = props.job

  useEffect(() => {
    let gallery1 = []
    job.beforeImages.map((photo) => {
      gallery1.push({
        original: photo.url,
        thumbnail: photo.thumbnail,
        description: photo.description,
        size: photo.size,
        extension: photo.extension,
        url: photo.url,
        height: 1,
        width: 1,
        image: photo.url,
      })
    })
    setBeforeImages(gallery1)
  }, [job])

  useEffect(() => {
    let gallery2 = []
    job.afterImages.map((photo) => {
      gallery2.push({
        original: photo.url,
        thumbnail: photo.thumbnail,
        description: photo.description,
        size: photo.size,
        extension: photo.extension,
        url: photo.url,
        height: 1,
        width: 1,
        image: photo.url,
      })
    })
    setAfterImages(gallery2)
  }, [job])

  const loadJob = (id) => {
    JobService.view(id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          console.log('loadjob', rs.data.data)
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }
  const onclickView = (item) => {
    setVisibleModalView(true)
    JobService.view(item.id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          setSelected.value = item
        }
      })
      .catch((err) => {
        message.error(err.response.message)
      })
  }

  const confirmStartWork = () => {
    JobService.start(job.id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          message.success(rs.data.message)
          props.onStartJob({
            data: rs.data.data,
            message: rs.data.message,
            success: rs.data.success,
          })
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }
  const confirmSendJob = () => {
    JobService.sendJob(job.id)
      .then((rs) => {
        console.log(rs.data)
        if (rs) {
          InformStore.setJob(rs.data.data)
          message.success(rs.data.message)
          props.onSendJob({
            data: rs.data.data,
            message: rs.data.message,
            success: rs.data.success,
          })
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }

  const cardStyle = {
    width: '360px',
    height: '192px',
    borderRadius: '16px',
    marginRight: '24px',
    boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)',
    backgroundColor: '#f4f4f4',
  }

  return (
    <Observer>
      {() => {
        return (
          <React.Fragment>
            {visibleModalView ? (
              <>
                <Modal
                  title={job.project ? job.project.name : job.id}
                  open={visibleModalView}
                  onCancel={() => setVisibleModalView(false)}
                  cancelText="ปิด"
                  destroyOnClose={true}
                  maskClosable={false}
                  okText={'ตกลง'}
                  okButtonProps={{
                    style: { display: 'none' },
                  }}
                  cancelButtonProps={{
                    type: 'primary',
                  }}
                  width={720}
                >
                  <JobView
                    job={InformStore.getJob}
                    reload={() => loadJob(InformStore.getJob.id)}
                  />
                </Modal>
              </>
            ) : null}
            <div
              style={{
                borderRadius: '0px',
                boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)',
                backgroundColor: '#f4f4f4',
                marginBottom: 15,
                border: 'solid 1px #a6a6a6',
              }}
            >
              <Card className={cardStyle}>
                <Row>
                  <Col {...colDate}>
                    <Row style={{ marginBottom: 15 }} gutter={(8, 8)}>
                      <Col>
                        <a onClick={() => onclickView(job)}>
                          <JobDateTime
                            start={job.start_time}
                            end={job.end_time}
                            jobStatus={job.job_status}
                          />
                        </a>
                      </Col>
                      <Col>
                        {/* แสดงลำดับ */}
                        {props.seq ? (
                          <span
                            style={{
                              padding: 5,
                            }}
                          >
                            ลำดับ {props.seq}
                          </span>
                        ) : (
                          ''
                        )}
                        <JobStatus
                          name={job.jobStatusName}
                          statusId={job.job_status}
                          style={{ padding: 3 }}
                        />
                        {/* เลขทีงาน */}
                        <span
                          style={{
                            marginLeft: 3,
                            color: '#ffffff',
                            padding: 5,
                            backgroundColor: '#222222',
                          }}
                        >
                          #{job.id}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col {...colDetail}>
                    <h2 style={{ fontSize: '1.2em' }}>
                      <a onClick={() => onclickView(job)}>
                        <strong style={{ color: '#222222' }}>{job.list}</strong>
                      </a>
                    </h2>

                    <div style={{ marginLeft: 10 }}>
                      <p
                        style={{
                          display: 'inline-block',
                        }}
                      >
                        {job.description}
                      </p>
                    </div>
                    <JobGroup group={job.group} groupId={job.group_id} />
                    <div>
                      <section
                        onClick={() => onclickView(job)}
                        style={{
                          cursor: 'pointer',
                          marginBottom: 7,
                        }}
                      >
                        <Row gutter={[16, 16]}>
                          {beforeImages && beforeImages.length > 0 ? (
                            <Col>
                              ภาพก่อนซ่อม
                              <Gallery data={beforeImages} />
                            </Col>
                          ) : null}

                          {afterImages && afterImages.length > 0 ? (
                            <Col>
                              ภาพหลังซ่อม
                              <Gallery data={afterImages} />
                            </Col>
                          ) : null}
                        </Row>
                      </section>
                    </div>

                    <Row>
                      <Col>
                        <div style={{ fontSize: 'normal' }}>
                          <UserOutlined />{' '}
                          {job.responsible_id
                            ? job.responsible_name
                            : 'ไม่ได้ระบุ'}{' '}
                          (ผู้รับผิดชอบ)
                          {job.technicians && job.technicians.length > 0 ? (
                            <>
                              <div
                                style={{
                                  border: 'solid 1px #cccccc',
                                  backgroundColor: '#f3f3f3',
                                  padding: 3,
                                }}
                              >
                                <JobTechnichian technicians={job.technicians} />
                              </div>
                            </>
                          ) : null}
                          {job.technician_name_other ? (
                            <>
                              <div
                                style={{
                                  border: 'solid 1px #cccccc',
                                  backgroundColor: '#f3f3f3',
                                  padding: 3,
                                }}
                              >
                                <UserOutlined /> {job.technician_name_other}{' '}
                                (ช่างอื่น ๆ)
                              </div>
                            </>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={[8]}>
                      <Col>
                        {job.project ? (
                          <div>
                            <HomeOutlined /> {job.project.name}
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                      <Col>
                        {job.home ? (
                          <div>
                            {job.home.home_no !== undefined
                              ? ' เลขที่ ' + job.home.home_no
                              : null}
                            {job.home.homeType &&
                            job.home.homeType.name !== undefined
                              ? ' (' + job.home.homeType.name + ')'
                              : null}
                            {job.home.plan_no !== undefined
                              ? ' แปลง ' + job.home.plan_no
                              : null}
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>

                    {job.start_job_at ? (
                      <Row>
                        <Col>
                          <div
                            style={{
                              color: '#222222',
                              backgroundColor: '#faeea9',
                              border: 'solid 1px #a6a6a6',
                              marginBottom: 5,
                              marginTop: 5,
                              padding: 3,
                            }}
                          >
                            <UserOutlined /> {job.start_job_user}{' '}
                            กดเริ่มทำงานแล้วเมื่อ{' '}
                            {Moment.unix(job.start_job_at).format('lll')}{' '}
                          </div>
                        </Col>
                      </Row>
                    ) : null}

                    {job.send_job_at > 0 ? (
                      <Row>
                        <Col>
                          <div
                            style={{
                              color: '#222222',
                              backgroundColor: '#faeea9',
                              border: 'solid 1px #a6a6a6',
                              marginBottom: 5,
                              marginTop: 5,
                              padding: 3,
                            }}
                          >
                            <UserOutlined /> {job.send_job_user} กดส่งงานเมื่อ{' '}
                            {Moment.unix(job.send_job_at).format('lll')}{' '}
                          </div>
                        </Col>
                      </Row>
                    ) : null}
                  </Col>
                </Row>
              </Card>
            </div>
          </React.Fragment>
        )
      }}
    </Observer>
  )
}
